/**
 * dashboard 為了兼容舊版 `/#path` 因此隔離出來
 * Dashboard 頁面路由流程：
 * 1. dashboardRoute 被打到後進入 Dashboard component
 * 2. 在 Dashboard component 根據 pageKey 判斷 要使用哪個頁面的
 * 如果需要過去是 `/#path` 的 route 用 `privilegedPagesProtected` 鎖權限
 * 需要帶 `opts: { isHashNeeded: true }` 才會在驗證時改成用 `/#path` 判斷
 */

const dashboardRoutes = [
  {
    pageKey: 'dashboard',
    exact: true,
    path: '/dashboard',
    text: '營運看板',
    icon: 'stock-market'
  }
]

module.exports = dashboardRoutes
